import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useRegion } from '../context/RegionContext';
import { detectUserCity, DEFAULT_CITY_SLUG } from '../utils/cityDetection';

export function CityRedirect() {
  const { regions, isLoading, setCurrentRegion, getRegionBySlug } = useRegion();
  const [detectedSlug, setDetectedSlug] = useState<string | null>(null);
  const [isTooFar, setIsTooFar] = useState(false);
  const [isDetecting, setIsDetecting] = useState(true);

  useEffect(() => {
    async function detect() {
      if (isLoading || regions.length === 0) return;

      // Start with default city immediately
      const defaultRegion = getRegionBySlug(DEFAULT_CITY_SLUG);
      if (defaultRegion) {
        setCurrentRegion(defaultRegion, true);
      }

      // Then try to detect user's actual location
      const result = await detectUserCity(regions);
      setDetectedSlug(result.slug);
      setIsTooFar(result.tooFar);

      // Update region based on detection
      const region = getRegionBySlug(result.slug);
      if (region) {
        setCurrentRegion(region, result.isAuto);
      }

      setIsDetecting(false);
    }

    detect();
  }, [regions, isLoading, setCurrentRegion, getRegionBySlug]);

  // Show loading while regions are loading
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full bg-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to default city immediately (detection continues in background)
  const targetSlug = detectedSlug || DEFAULT_CITY_SLUG;

  // If still detecting, redirect to default
  if (isDetecting) {
    return <Navigate to={`/${DEFAULT_CITY_SLUG}`} replace />;
  }

  // Pass tooFar flag via query param so MapPage can show toast
  const queryParam = isTooFar ? '?tooFar=true' : '';
  return <Navigate to={`/${targetSlug}${queryParam}`} replace />;
}
